module.exports = __webpack_public_path__ + "static/media/FIVE.2b2a2f42.png";